jQuery(function( $ ) {
	'use strict'

	// An object that handles the display of a input modal

    window.InputModalManager = {

        defaultTitle        : 'Input',
        defaultButtonText 	: 'OK',

        modal               : $( '#modal-input' ),
		input  				: $( '#modal-input input' ),
		confirmationButton  : $( '#modal-input .btn-confirm' ),

        callback            : null,

        show : function( args ) {
            if ( ! args.title ) {
                args.title = this.defaultTitle;
            }
            if ( ! args.inputText ) {
                args.inputText = '';
            }
            if ( ! args.buttonText ) {
                args.buttonText = this.defaultButtonText;
            }

            if ( args.callback ) {
                this.callback = args.callback;
            }

            this.modal.find( '.modal-title' ).text( args.title );
            this.confirmationButton.text( args.buttonText );

            this.confirmationButton.off( 'click' );

            this.input.val( args.inputText );
            this.modal.modal();
            this.input.focus();

			this.input.on( 'keypress', function(e) {
				if ( e['charCode'] == 13 ) {
					e.preventDefault();
					window.InputModalManager.submit() ;
				}
			});

            this.confirmationButton.on( 'click', window.InputModalManager.submit );

        },

		submit : function() {
			window.InputModalManager.modal.modal( 'hide' );
			if ( window.InputModalManager.callback ) {
				window.InputModalManager.callback( window.InputModalManager.input.val() );
			}
		}

    };

});
